export const TAGS_URL = '/storage/v1/tag';
export const DOWNLOAD_URL = '/storage/v1/secure/download';
export const ATTACHMENT_DOWNLOAD_URL = '/storage/v1/secure/attachment/download';

export const TAG_DATA_KEYS = {
    id: 'id',
    tags: 'tags'
};

export const LINK_DATA_KEYS = {
    isLink: 'isLink',
    linkURL: 'linkURL',
    linkName: 'linkName'
};

export const COMMON_TYPES = {
    object: 'object',
    number: 'number',
    units: 'units'
};

export const COMMON_FIELDS = {
    id: 'id'
};

export const DEFAULT_TRUNCATION_LENGTH = 60;
